/**
 * Cusom Shopify Theme designed for Etiquette Clothiers
 * ----------------------------------------------------
 * Author: TIVLABS
 * Last modified: May 20, 2016
 **/
var image_carousel_transition_speed = 'slow';

jQuery(document).ready(function() {
  
  jQuery('.image-carousel[data-loadslidestpl*="[NUM]"]').not('.load-lazy').each(function(i, image_carousel) {
    image_carousel_load_next_slide(jQuery(image_carousel));
  });
  jQuery('.image-carousel').not('[data-loadslidestpl*="[NUM]"]').not('.load-lazy').each(function(i, image_carousel) {
    image_carousel_reposition_all_slides(jQuery(image_carousel));
  });
  
  jQuery('body').on('click', '.image-carousel > a.prev, .image-carousel > a.next', function(e) {
    e.preventDefault();
    var $this = jQuery(this);
    var $image_carousel = $this.closest('.image-carousel');
    if($image_carousel.hasClass('sliding')
    || $image_carousel.hasClass('loading-slides')) return false;
    image_carousel_slide($image_carousel, $this.hasClass('next') ? 'right' : 'left');
  });
  
});

jQuery(window).load(function() {
  
  jQuery('.image-carousel.load-lazy[data-loadslidestpl*="[NUM]"]').each(function(i, image_carousel) {
    image_carousel_load_next_slide(jQuery(image_carousel));
  });
  jQuery('.image-carousel.load-lazy').not('[data-loadslidestpl*="[NUM]"]').each(function(i, image_carousel) {
    image_carousel_reposition_all_slides(jQuery(image_carousel));
  });

  var ic_handle_window_resize = function() {
    if(window.ic_custom_handle_window_resize_before) ic_custom_handle_window_resize_before();
    jQuery('.image-carousel').each(function(i, image_carousel) {
      var $image_carousel = jQuery(image_carousel);
      if($image_carousel.hasClass('loading-slides')) return false;
      image_carousel_reposition_all_slides($image_carousel);
    });
    if(window.ic_custom_handle_window_resize_after) ic_custom_handle_window_resize_after();
  }, ic_resizing_interval;
  
  window.onresize = function() {
    clearTimeout(ic_resizing_interval);
    ic_resizing_interval = setTimeout(ic_handle_window_resize, 1000);
  };
  
});

function image_carousel_slide($image_carousel, dir) {
  var $visible_slides,
      width_to_slide,
      width_filled_up = 0;
  $image_carousel.find('ul.slides li:visible').each(function(i, slide) {
    if(ic_is_visible(jQuery(slide))) {
      $visible_slides = typeof($visible_slides) == 'undefined' ? jQuery(slide) : $visible_slides.add(jQuery(slide));
    }
  });
  $image_carousel.addClass('sliding');
  if(dir == 'right') {
    width_to_slide = $image_carousel.width(); //ic_visible_width($visible_slides.first());
    while(width_filled_up < width_to_slide) {
      var $adjacent_slide = $visible_slides.last().next();
      if($adjacent_slide.length == 0) {
        $adjacent_slide = $image_carousel.find('ul.slides li:first-child');
        $adjacent_slide.insertAfter($visible_slides.last());
      }
      $adjacent_slide.show().css({ opacity: '0' });
      width_filled_up += ic_max_width($adjacent_slide);
      $adjacent_slide.attr('style', 'left: '+($visible_slides.last().offset().left + ic_max_width($visible_slides.last()))+'px');
      $visible_slides = $visible_slides.add($adjacent_slide);
    } /*console.log('RIGH', $visible_slides);*/
    $visible_slides.each(function(i, visible_slide) {
      jQuery(visible_slide).animate({ left: parseInt(jQuery(visible_slide).css('left')) - width_to_slide }, image_carousel_transition_speed, function() {
        if(!ic_is_visible(jQuery(visible_slide)))
          jQuery(visible_slide).attr('style', 'display: none');
        $image_carousel.removeClass('sliding');
      });
    });
  } else {
    width_to_slide = $image_carousel.width(); //ic_visible_width($visible_slides.last());
    while(width_filled_up < width_to_slide) {
      var $adjacent_slide = $visible_slides.first().prev();
      if($adjacent_slide.length == 0) {
        $adjacent_slide = $image_carousel.find('ul.slides li:last-child');
        $adjacent_slide.insertBefore($visible_slides.first());
      }
      $adjacent_slide.show().css({ opacity: '0' });
      width_filled_up += ic_max_width($adjacent_slide);
      $adjacent_slide.attr('style', 'left: '+($visible_slides.first().offset().left - ic_max_width($adjacent_slide))+'px');
      $visible_slides = $adjacent_slide.add($visible_slides);
    } /*console.log('LEFT', $visible_slides);*/
    $visible_slides.each(function(i, visible_slide) {
      jQuery(visible_slide).animate({ left: parseInt(jQuery(visible_slide).css('left')) + width_to_slide }, image_carousel_transition_speed, function() {
        if(!ic_is_visible(jQuery(visible_slide)))
          jQuery(visible_slide).attr('style', 'display: none');
        $image_carousel.removeClass('sliding');
      });
    });
  }
}

function image_carousel_load_next_slide($image_carousel) {
  var loadslidestpl = $image_carousel.data('loadslidestpl'),
      lst_index = $image_carousel.data('lst_index'),
      lst_limit = $image_carousel.data('lst_limit');
  if(typeof(lst_index) == 'undefined') {
    loadslidestpl = $image_carousel.attr('data-loadslidestpl');
    lst_limit = $image_carousel.attr('data-lstlimit');
    lst_index = 0;
    $image_carousel
      .addClass('loading-slides')
      .removeAttr('data-loadslidestpl')
      .removeAttr('data-lstlimit')
      .data('loadslidestpl', loadslidestpl)
      .data('lst_index', 0)
      .data('lst_limit', lst_limit);
  }
  $image_carousel.data('lst_index', ++lst_index);
  if(typeof(lst_limit) != 'undefined'
  && lst_index > lst_limit) {
    $image_carousel.removeClass('loading-slides');
    return;
  }
  var imgobj = new Image();
  imgobj.src = loadslidestpl.replace('[NUM]', lst_index);
  imgobj.onload = function() {
    image_carousel_insert_slide($image_carousel, this.src);
    image_carousel_load_next_slide($image_carousel);
  };
  imgobj.onerror = function() {
    $image_carousel.removeClass('loading-slides');
  };
}

function image_carousel_insert_slide($image_carousel, slide_image) {
  var $new_slide = jQuery('<li style="display: none" />');
  $new_slide.html(
    '<a href="'+slide_image+'" style="background-image: url('+slide_image+')">'
      +'<img src="'+slide_image+'" />'
    +'</a>'
  );
  $image_carousel.find('ul.slides').append($new_slide);
  image_carousel_position_slide($image_carousel, $new_slide);
  
  /*var $slides_container = $image_carousel.find('ul.slides'),
      $slides = $image_carousel.find('ul.slides li'),
      new_slide_offset = 0;
  $slides.filter(':visible').each(function(i, slide) {
    
  });*/
}

function image_carousel_position_slide($image_carousel, $new_slide) {
  var $slides_container = $image_carousel.find('ul.slides'),
      $slides = $image_carousel.find('ul.slides li'),
      new_slide_offset = 0;
  $slides.filter(':visible').each(function(i, slide) {
    new_slide_offset += ic_max_width(jQuery(slide));
  });
  if(new_slide_offset < jQuery(window).width())
    $new_slide.css({ left: new_slide_offset }).fadeIn('fast');
}

function image_carousel_reposition_all_slides($image_carousel) {
  var $image_carousel_slides = $image_carousel.find('ul.slides > li');
  $image_carousel_slides.attr('style', 'display: none;');
  $image_carousel_slides.each(function(i, image_carousel_slide) {
    var $image_carousel_slide = jQuery(image_carousel_slide);
    image_carousel_position_slide($image_carousel, $image_carousel_slide);
  });
}

function ic_is_visible($element) {
  return ($element.offset().left >= 0 && $element.offset().left < jQuery(window).width())
  || (($element.offset().left + ic_max_width($element)) > 0 && ($element.offset().left + ic_max_width($element)) < jQuery(window).width());
}

function ic_visible_width($element) {
  var left_end = $element.offset().left,
      right_end = $element.offset().left + ic_max_width($element);
  if(left_end <= 0 && right_end > 0) {
    return right_end;
  } else if(left_end < jQuery(window).width() && right_end >= jQuery(window).width()) {
    return jQuery(window).width() - left_end;
  } else if(left_end >= 0 && right_end <= jQuery(window).width()) {
    return $element.width();
  } else return 0;
}

function ic_max_width($element) {
  return Math.max($element.width(), $element.outerWidth());
}